import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from '../Parts/Button.jsx';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { HTTP_500_INTERNAL_SERVER_ERROR_CODE } from '../../constants/HttpStatusCode';

const styles = () => ({
  root: {
    width: '100%',
    height: '100vh',
    backgroundColor: '#2B344B'
  },

  container: {
    width: '100%',
    height: '83vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  content: {
    maxWidth: '300px',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  desert: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
  },

  moon: {
    position: 'fixed',
    top: 80,
    right: 80,
    width: '140px',
  },

  logo: {
    position: 'fixed',
    top: 50,
    left: 50,
    width: '110px',
  },

  logoSL: {
    position: 'fixed',
    top: 50,
    left: 50,
    height: '25px',
  },

  logoKL: {
    position: 'fixed',
    top: 50,
    left: 50,
    height: '35px',
  }
});

const messages = {
  400: {
    title: "リクエストが拒否されました…",
    text: "リクエストの形式が正しくないようです。ご確認の上、もう一度お試しください。"
  },
  404: {
    title: "お探しのページは見つかりませんでした…",
    text: "入力したURLが間違っている可能性があります。ご確認の上、もう一度お試しください。"
  },
  500: {
    title: "サーバーから応答がありません…",
    text: '申し訳ございませんが、現在ご利用できません。再読み込みしても改善しない場合は、しばらくたってから、もう一度お試しください。'
  },
}

const ErrorPage = props => {
  const { classes, code } = props;

  let logo, logoClass;
  logo = 'smart-letter-logo-white.png'
  logoClass = 'logoKL'

  return (
    <div className={classes.root}>
      <img alt="posto.svg" src={require(`../../assets/images/${logo}`)} className={classes[logoClass]} />
      <img alt="moon.svg" src={require('../../assets/images/moon.svg')} className={classes.moon} />
      <img alt="desert.svg" src={require('../../assets/images/desert.svg')} className={classes.desert} />

      <div className={classes.container}>
        <div className={classes.content}>
          <Typography variant="display4" style={{ color: '#FFFFFF' }}>{code ? code : ''}</Typography>
          <Typography
            variant="subheading"
            style={{
              color: '#FFFFFF',
              textAlign: 'center',
              paddingTop: '12px',
              fontWeight: 'bold',
            }}>
            {(code && messages[code]) ? messages[code].title : "エラーが発生しました…"}
          </Typography>
          <Typography
            variant="body2"
            style={{
              color: '#FFFFFF',
              paddingTop: '20px',
            }}>
            {(code && messages[code]) ? messages[code].text : "申し訳ございませんが、現在ご利用できません。再読み込みしても改善しない場合は、しばらくたってから、もう一度お試しください。"}
          </Typography>
          <Button
            text="ホームへ戻る"
            handleClickButton={() => {
              if (props.currentPath === '/') {
                window.location.reload();
              } else {
                // ダッシュボードにURLを変更してリロードさせる
                props.goToDashboard();
                window.location.reload();
              }
            }}
            fullWidth={true}
            style={{
              marginTop: '40px'
            }}
          >
          </Button>
        </div>
      </div>
    </div>
  );
}

ErrorPage.propTypes = {
  code: PropTypes.number,
  classes: PropTypes.object.isRequired,
  currentPath: PropTypes.string,
  goToDashboard: PropTypes.func,
};

ErrorPage.defaultProps = {
  code: HTTP_500_INTERNAL_SERVER_ERROR_CODE
};

const mapStateToProps = (state) => {
  return {
    currentPath: state.router.location.pathname,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    goToDashboard: () => dispatch(push('/')),
  }
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorPage));



// WEBPACK FOOTER //
// ./src/components/Error/ErrorPage.jsx